import { render, staticRenderFns } from "./progress-achievements.vue?vue&type=template&id=1b732b56&"
import script from "./progress-achievements.vue?vue&type=script&lang=js&"
export * from "./progress-achievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports